import React from "react";

import "../../App.css";
import InstagramIntegration from "./components/InstagramIntegration";
import Section from "../../../layouts/core/Section";
import {Header} from "../../../layouts/core/Header";
import Title from "../../../layouts/core/Title";
import Body from "../../../layouts/core/Body";
import BackButton from "../../commons/BackButton";
import ScaleflexIntegration from "./components/ScaleflexIntegration";
import WhatsappIntegration from "./components/WhatsappIntegration";

export default function Integrations() {
  return (
    <Section>
      <Header>
        <Title>Integrations</Title>
        <div className="ms-auto">
          <BackButton />
        </div>
      </Header>
      <Body>
        <div className="d-flex">
          <InstagramIntegration />
          <WhatsappIntegration />
          <ScaleflexIntegration />
        </div>
      </Body>
    </Section>
  );
}
